//---------------------------------------------------------------------------------------------
// Sine
//---------------------------------------------------------------------------------------------

export const SineIn = (k: number): number => {
  return 1 - Math.cos((k * Math.PI) / 2);
};

export const SineOut = (k: number): number => {
  return Math.sin((k * Math.PI) / 2);
};

export const SineInOut = (k: number): number => {
  return 0.5 * (1 - Math.cos(Math.PI * k));
};
